import { RootDispatch } from "redux/rootReducer";
import { load, loadSuccess, loadFail } from "./profitsAndLossesActions";
import * as request from "utility/request";
import { PortfolioProfitsAndLosses } from "types/ProfitsAndLosses";

const apiUrl = process.env.REACT_APP_API_URL;

export const loadProfitsAndLosses = (
  reportControlId: string,
  startDate: string,
  endDate: string
) => {
  return async (dispatch: RootDispatch) => {
    dispatch(load());

    try {
      const res = await request.getResponseJson<PortfolioProfitsAndLosses[]>(
        `${apiUrl}/api/profitsAndLosses?reportControlId=${reportControlId}&startDate=${startDate}&endDate=${endDate}`
      );

      dispatch(loadSuccess(res));
    } catch (error) {
      return request.handleFetchError(dispatch, error, loadFail(error));
    }
  };
};
